import { BELONGS_TO } from 'fe-core/Entities/relationshipTypes';
import { ACTION_UPDATE } from 'fe-core/module-constants';
import { createResource } from 'fe-core/Resources';
import { update } from 'fe-core/Resources/actions';

const ClaimRequest = createResource({
  name: 'claimRequest',
  schema: {
    attributes: ['createdAt', 'status'],
    relationships: {
      shift: {
        relationshipType: BELONGS_TO,
        inverseOf: 'claimRequests',
      },
      job: {
        relationshipType: BELONGS_TO,
        inverseOf: 'claimRequests',
      },
    },
  },
});

ClaimRequest.approve = id =>
  update({
    path: `/schedule_builder/claim_requests/${id}/approve`,
    name,
    action: ACTION_UPDATE,
  });

export default ClaimRequest;
